import React, { FC, useEffect, useState } from "react";
import { Row, Col, Button, Dropdown, Menu, Image, List, Avatar } from "antd";
import { MoreOutlined } from "@ant-design/icons";
import {
  RSVPRespModal,
  RxSensorTableModal,
  CameraVideoModal,
  EditPaymentModal,
} from "components/Modals";
import {
  GET_USER_BY_ID,
} from "reducers/authReducer";
import { useDispatch, useSelector } from "react-redux";
import MapService from "../MapPanel/MapService";
import moment from "moment";
import {
  getTwilioRecordedVideoRecordingPublishTopic,
  getTwilioRecordedVideoSubscriptionTopic,
} from "hooks/MQTTConstants";
import { RootState } from "reducers/rootReducer";
import { MapTopics, SocketTopics } from "../../../constants/enums";
import VideoPlayerModal from "components/Modals/VideoPlayerModal";
import { useEventSubscriber } from "utils/event";
import { popupCenter } from "utils/appUtil";
import { toast } from 'react-toastify';
import QuoteMessage from "./QuoteMessage";
import MessageBox from "./MessageBox";
import MessageInfoBox from "./MessageInfoBox";
import { MessageTypes } from "../../../constants/enums";


const MessageItem: FC<{
  screens: ScreenStateObj;
  setScreens: React.Dispatch<React.SetStateAction<ScreenStateObj>>;
  socket: ISocket;
  message: MessageObj;
  onMessageVisible: () => void;
  onEdit: (message: MessageObj) => void;
  onRemove: (message: MessageObj) => void;
  page: SelectedSearchItem | undefined;
  readBy: SelectedSearchItem[] | undefined;
  onEvent: (event: string, mode?: any) => void;
  onReply: (message: MessageObj) => void;
  onForwardMessagePopupOpen: (message: MessageObj) => void;
}> = ({
  screens,
  setScreens,
  socket,
  message,
  onMessageVisible,
  onEdit,
  onRemove,
  page,
  readBy,
  onEvent,
  onReply,
  onForwardMessagePopupOpen
}) => {
    const { allUsers } = useSelector((state: RootState) => state.auth);
    const [rsvpModalOpen, setRSVPModalOpen] = useState<boolean>(false);
    const [paymentModalOpen, setPaymentModalOpen] = useState<boolean>(false);
    const [videoPlayerOpen, setVideoPlayerOpen] = useState<boolean>(false);
    const [rxSensorDevice, setRxSensorDevice] = useState<boolean>(false);
    const [cameraVideo, setCameraVideo] = useState<boolean>(false);
    const [seenByUsers, setSeenByUsers] = useState<any[]>([]);
    const [username, setUsername] = useState<string | undefined>(
      message.senderName
    );

    const [userProfileImage, setUserProfileImage] = useState<any>(
      "/images/users/user.png"
    );
    const { showGPSHistorical } = MapService();

    useEffect(() => {
      const userId: string | undefined = message.senderName?.split("# ")[1];
      const user = allUsers?.find((obj) => obj.id === userId);
      if (userId === process.env.REACT_APP_AI_ASSISTANT_USER_ID) {
        setUsername('beam.aiassistant');
      }
      else if (user?.beamId) {
        setUsername(user?.beamId);
      } else {
        setUsername(message.senderName);

        // dispatch(
        //   GET_USER_BY_ID({
        //         userId,
        //         callback: (resp) => {
        //           // if (resp?.data?.workflowId) {
        //           //   subscribeToWorkflowEvents(resp?.data?.workflowId);
        //           // }
        //           // console.log('response', resp);
        //           // callback && callback(resp);
        //           console.log('get user info', )
        //         },
        //       })
        //     );

      }
      setUserProfileImage(
        user?.profileImage?.urls?.original?.url ?? "/images/users/user.png"
      );
      onMessageVisible();
      // console.log('message', message.senderName);
    }, [message.senderName, allUsers]);

    useEffect(() => {
      let read = page?.readBy?.[parseInt(message.id.toString())] ?? undefined;
      if (read && read.length > 0) {
        let _seenByUsers = [];
        read = read.filter((x) => {
          return x !== localStorage.getItem("RID");
        });
        read.map((x, index) => {
          const user = allUsers?.find((obj) => obj.id === x);
          _seenByUsers.push({
            beamId: user?.beamId || `user# ${x}`,
            profileImage:
              user?.profileImage?.urls?.original?.url ?? "/images/users/user.png",
          });
        });
        if (read.length > 0) {
          setSeenByUsers(_seenByUsers);
        }
      } else {
        setSeenByUsers([]);
      }
    }, [page, allUsers]);

    const copyToClipboard = async (text) => {
      try {
        await navigator.clipboard.writeText(message.data.body);
        toast.success('Copied to clipboard!', {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 2000
        });
      } catch (error) {
        console.error('Failed to copy text to clipboard:', error);
      }
    };

    const dispatch = useDispatch();

    const editMenu = (
      <div className="menu-container edit-menu pr-0 pl-0">
        {message.senderId.toString() === localStorage.getItem("RID") && (
          <button role="menuitem" className="btn-menu w-full" aria-label="Edit"
            onClick={() => {
              if (
                message.messageType === MessageTypes.Text ||
                message.messageType === MessageTypes.Media
              ) {
                onEdit(message);
              } else if (message.messageType === MessageTypes.Place) {
                dispatch({ type: "SET_MAP_TYPE", payload: "PAGE" });
                socket.subscribeToEvent(
                  SocketTopics.SubscribePageTopics,
                  `${process.env.REACT_APP_ECO_SYSTEM
                  }/connection/${localStorage.getItem(
                    "CID"
                  )}/connection/${localStorage.getItem("CID")}/focusMap`
                );
                socket.publishToEvent(
                  SocketTopics.PublishPageTopics,
                  // MapTopics.FocusMap,
                  `${process.env.REACT_APP_ECO_SYSTEM
                  }/connection/${localStorage.getItem(
                    "CID"
                  )}/connection/${localStorage.getItem("CID")}/focusMap`,
                  {
                    type: "ADD_SELECTED_PLACES",
                    payload: {
                      ...message,
                      id: message.id,
                      name: message.message,
                      objectType: "place",
                    },
                  }
                );
                socket.publishToEvent(
                  SocketTopics.PublishPageTopics,
                  `${process.env.REACT_APP_ECO_SYSTEM
                  }/connection/${localStorage.getItem(
                    "CID"
                  )}/connection/${localStorage.getItem("CID")}/focusMap`,
                  {
                    type: "EDIT_PLACE",
                    payload: {
                      id: message.id,
                      type: message?.data?.display?.type,
                    },
                  }
                );

                return;
              } else if (message.messageType === MessageTypes.Event) {
                onEvent(MessageTypes.Event, "edit");
              } else if (message.messageType === MessageTypes.Pay) {
                onEvent(MessageTypes.Pay, "edit");
              }
            }}
          >
            <div style={{ background: "url(/images/Edit.png)" }}
              className="r-dv">
            </div>
            <div className="css-1dbjc4n r-1habvwh r-18u37iz">
              <div data-text-as-pseudo-element="Edit" dir="auto" className="btn-edit">
              </div>
            </div>
          </button>
        )}
        <button onClick={copyToClipboard} role="menuitem" className="btn-menu w-full" aria-label="Copy">
          <div style={{ background: "url(/images/Copy.png)" }}
            className="r-dv">
          </div>
          <div className="css-1dbjc4n r-1habvwh r-18u37iz">
            <div data-text-as-pseudo-element="Copy" dir="auto" className="btn-edit">
            </div>
          </div>
        </button>
        <button onClick={() => onReply(message)} role="menuitem" className="btn-menu w-full" aria-label="Reply">
          <div style={{ background: "url(/images/Reply.png)" }}
            className="r-dv">
          </div>
          <div className="css-1dbjc4n r-1habvwh r-18u37iz">
            <div data-text-as-pseudo-element="Reply" dir="auto" className="btn-edit">
            </div>
          </div>
        </button>
        <button onClick={() => onForwardMessagePopupOpen(message)} role="menuitem" className="btn-menu w-full" aria-label="Forward">
          <div style={{ background: "url(/images/Forward.png)" }}
            className="r-dv">
          </div>
          <div className="css-1dbjc4n r-1habvwh r-18u37iz">
            <div data-text-as-pseudo-element="Forward" dir="auto" className="btn-edit">
            </div>
          </div>
        </button>
        {message.senderId.toString() === localStorage.getItem("RID") && (
          <button role="menuitem" className="btn-menu w-full" aria-label="Remove"
            onClick={() => {
              onRemove(message);
            }}
          >
            <div style={{ background: "url(/images/Dismiss.png)" }}
              className="r-dv">
            </div>
            <div className="css-1dbjc4n r-1habvwh r-18u37iz">
              <div data-text-as-pseudo-element="Remove" dir="auto" className="btn-edit">
              </div>
            </div>
          </button>
        )}
      </div>
    );

    const seenByMenu = () => {
      let read = page?.readBy?.[parseInt(message.id.toString())] ?? undefined;
      let readUserName = [];
      if (read && read.length > 0) {
        read = read.filter((x) => {
          return x !== localStorage.getItem("RID");
        });
        read.map((x, index) => {
          const user = allUsers?.find((obj) => obj.id === x);
          readUserName.push({
            beamId: user?.beamId || `user# ${x}`,
            profileImage:
              user?.profileImage?.urls?.original?.url ?? "/images/users/user.png",
          });
        });
      }

      return (
        <div style={{ overflow: "hidden" }} className="menu-container seen-by-container edit-menu">
          <div className="mb-3">
            <h6>Read by {readUserName.length > 1 ? readUserName.length : ""}</h6>
          </div>
          {readUserName.map((user, index) => (
            <Row key={index} className="mb-2 align-items-center">
              <Col span={4}>
                <img
                  src={user.profileImage}
                  width="25"
                  height="25"
                  style={{ borderRadius: "50%" }}
                />
              </Col>
              <Col className="ml-1" span={6}>
                <p>{user.beamId}</p>
              </Col>
            </Row>
          ))}
        </div>
      );
    };

    const handleIconClick = () => {
      if (message.messageType === MessageTypes.Rsvp) {
        setRSVPModalOpen(true);
        return;
      }
      if (
        message.messageType === MessageTypes.Pay &&
        (!message.data?.status || message.data?.status !== "succeeded")
      ) {
        setPaymentModalOpen(true);
        return;
      }
      if (message.messageType === MessageTypes.Place) {
        dispatch({ type: "SET_MAP_TYPE", payload: "PAGE" });
        socket.subscribeToEvent(
          SocketTopics.SubscribePageTopics,
          `${process.env.REACT_APP_ECO_SYSTEM}/connection/${localStorage.getItem(
            "CID"
          )}/connection/${localStorage.getItem("CID")}/focusMap`
        );
        socket.publishToEvent(
          SocketTopics.PublishPageTopics,
          `${process.env.REACT_APP_ECO_SYSTEM}/connection/${localStorage.getItem(
            "CID"
          )}/connection/${localStorage.getItem("CID")}/focusMap`,
          {
            type: "ADD_SELECTED_PLACES",
            payload: {
              ...message,
              id: message.id,
              name: message.message,
              objectType: "place",
            },
          }
        );
        return;
      }

      if (message.messageType === MessageTypes.Event) {
        onEvent(MessageTypes.Event);
        return;
      }

      if (message.messageType === MessageTypes.AlertConfiguration) {
        onEvent("alert");
        return;
      }

      if (
        message.messageType === MessageTypes.GPSReport ||
        message.messageType === MessageTypes.Alert
      ) {
        dispatch({ type: "SET_MAP_TYPE", payload: "PAGE" });
        showGPSHistorical(
          message,
          message.data.startIotAt,
          message.data.endIotAt
        );
      }

      if (message.messageType === MessageTypes.GPS) {
        dispatch({ type: "SET_MAP_TYPE", payload: "PAGE" });
        socket.subscribeToEvent(
          SocketTopics.SubscribePageTopics,
          // MapTopics.FocusMap
          `${process.env.REACT_APP_ECO_SYSTEM}/connection/${localStorage.getItem(
            "CID"
          )}/connection/${localStorage.getItem("CID")}/focusMap`
        );
        socket.publishToEvent(
          SocketTopics.PublishPageTopics,
          // MapTopics.FocusMap,
          `${process.env.REACT_APP_ECO_SYSTEM}/connection/${localStorage.getItem(
            "CID"
          )}/connection/${localStorage.getItem("CID")}/focusMap`,
          {
            type: "ADD_SELECTED_PLACES",
            payload: {
              ...message,
              id: message.id,
              name: message.message,
              objectType: "user",
            },
          }
        );
        return;
      }
      if (message.messageType === MessageTypes.VideoRecording) {
        socket.subscribeToEvent(
          SocketTopics.SubscribePageTopics,
          getTwilioRecordedVideoSubscriptionTopic()
        );
        socket.publishToEvent(
          SocketTopics.PublishPageTopics,
          getTwilioRecordedVideoRecordingPublishTopic(),
          {
            id: message.data.data?.id,
          }
        );
        return;
      }
      if (message.messageType === MessageTypes.Rx) {
        // redirecthere
        onEvent(MessageTypes.Rx);


      }
      if (message.messageType === MessageTypes.Summary) {
        window.open(message.data?.url, "_blank");
      }

      if (message.messageType === MessageTypes.Survey) {
        console.log('survey message', message);
        if (message?.data?.urls?.original?.url) {
          popupCenter(
            `${message?.data?.urls?.original?.url}&userId=${localStorage.getItem("RID")}`,
            "Survey",
            window.innerWidth * 0.7,
            window.innerHeight * 0.9
          );
        }
        else {
          popupCenter(
            `${process.env.REACT_APP_SHARED_URI}/survey?mode=edit&userId=${page?.persistent?.static?.iotAsset?.config?.configUserId
            }&surveyId=${message.data.surveyId}&type=survey&cudbServiceId=${page?.persistent?.static?.iotAsset?.config?.configUserCudbServiceId
            }&connectionId=${localStorage.getItem(
              "CID"
            )}&liveUserId=${localStorage.getItem("RID")}&pageId=${page.pageId}`,
            "Survey",
            window.innerWidth * 0.7,
            window.innerHeight * 0.9
          );
        }
      }

      if (message.messageType === MessageTypes.Cam) {
        setCameraVideo(true);
      }

      if (message.messageType === MessageTypes.Media) {
        if (message.data?.mimeType === "video/hls") {
          // Handle HLS video: stop RTSP stream, start new one, then open viewer
          const handleHlsVideo = async () => {
            if (!page?.pageId || !message.data?.urls?.original?.name || !message.data?.urls?.original?.url) {
              toast.error('Missing required data for RTSP stream', {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 2000
              });
              return;
            }

            try {
              // First API call: Stop RTSP stream
              const stopUrl = `${process.env.REACT_APP_VIDEO_URI}/api/rtsp/stop?streamName=${message.data.urls.original.name}&roomName=${page.pageId}`;
              const stopResponse = await fetch(stopUrl, {
                method: 'GET',
                headers: {
                  'Content-Type': 'application/json',
                },
              });

              // if (!stopResponse.ok) {
              //   throw new Error(`Failed to stop RTSP stream: ${stopResponse.statusText}`);
              // }

              // Second API call: Start RTSP stream
              const startUrl = `${process.env.REACT_APP_VIDEO_URI}/api/rtsp/start?rtspUrl=${message.data.urls.original.url}&roomName=${page.pageId}&streamName=${message.data.urls.original.name}`;
              const startResponse = await fetch(startUrl, {
                method: 'GET',
                headers: {
                  'Content-Type': 'application/json',
                },
              });

              if (!startResponse.ok) {
                throw new Error(`Failed to start RTSP stream: ${startResponse.statusText}`);
              }

              // Open viewer page in new tab
              window.open(`${process.env.REACT_APP_VIDEO_URI}/?pageId=${page.pageId}&viewer=true`, "_blank");
            } catch (error) {
              console.error('Error handling HLS video:', error);
              const errorMessage = error instanceof Error ? error.message : 'Unknown error occurred';
              toast.error(`Failed to setup RTSP video stream: ${errorMessage}`, {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 3000
              });
            }
          };

          handleHlsVideo();
        } else if (message.data?.mimeType?.indexOf("video") !== -1) {
          setVideoPlayerOpen(true);
        } else {
          window.open(message.data.urls.original.url, "_blank");
        }
      }
      if (message.messageType === MessageTypes.SoundRecording) {
        window.open(message.data?.data?.url, "_blank");
      }
    };
    // in case of new attributes, store them from useMQTTService()
    return (
      <React.Fragment>
        {message.messageType === MessageTypes.Info &&
          (<MessageInfoBox username={username} profileImg={userProfileImage} message={message}></MessageInfoBox>)
        }
        {message.messageType !== MessageTypes.Info && (
          <div style={{ display: "flex" }}
            className={`${localStorage.getItem("RID") === message.senderId.toString()
              ? "message-div-right"
              : ""
              }`}
          >

            <div className={`message-item`} id={message?.id?.toString()}>
              {(message?.refMessage?.pageMessage && message?.refMessage?.referenceType == "refer") &&
                (<QuoteMessage message={message.refMessage.pageMessage} />)
              }
              <div className="user-info">
                <div className="d-flex">
                  <img
                    src={userProfileImage}
                    className="user-avatar"
                    style={{ borderRadius: "50%" }}
                  />
                  <h4>{username}</h4>
                  <span>
                    {message.originalCreatedAt
                      ? moment(message.originalCreatedAt).format("hh:mm a")
                      : moment(message.createdAt).format("hh:mm a")}
                  </span>
                </div>
                <div className="d-flex">
                  {message.messageType !== MessageTypes.Text &&
                    message.messageType !== MessageTypes.Info &&
                    message.messageType !== MessageTypes.Survey &&
                    message.messageType !== MessageTypes.RsvpResponse && (
                      <img
                        onClick={handleIconClick}
                        className="ml-2 message-type cursor-pointer"
                        src={`/images/${message.messageType}-icon.png`}
                      />
                    )}
                    {message.messageType === MessageTypes.Survey && (
                      <img
                        onClick={handleIconClick}
                        className="ml-2 message-type cursor-pointer"
                        src={`/images/summary-icon.png`}
                      />
                    )}
                  {message?.refMessage?.referenceType == "update" &&
                    (<small>Edited</small>)
                  }
                </div>
              </div>

              <MessageBox message={message} onOpen={handleIconClick} />

              {rsvpModalOpen && (
                <RSVPRespModal
                  onClose={() => setRSVPModalOpen(false)}
                  rsvp={message}
                />
              )}
              {paymentModalOpen && (
                <EditPaymentModal
                  onClose={() => setPaymentModalOpen(false)}
                  pay={message}
                  socket={socket}
                />
              )}
              {rxSensorDevice && (
                <RxSensorTableModal
                  onClose={() => setRxSensorDevice(false)}
                  sensorObj={message}
                  socket={socket}
                />
              )}
              {cameraVideo && (
                <CameraVideoModal
                  onClose={() => setCameraVideo(false)}
                  sensorObj={message}
                  socket={socket}
                />
              )}
              {videoPlayerOpen && (
                <VideoPlayerModal
                  url={message.data?.urls?.original?.url}
                  onClose={() => setVideoPlayerOpen(false)}
                />
              )}
            </div>

            <div>
              <Dropdown
                overlay={editMenu}
                className="message-dropdown"
                placement="bottomRight"
              >
                <MoreOutlined className="ant-dropdown-link" style={{ cursor: 'pointer' }} onClick={(e) => e.preventDefault()} />
              </Dropdown>
            </div>
          </div>
        )}

        {message.messageType !== MessageTypes.Info && seenByUsers.length > 0 && (
          <Dropdown
            key={'seen-' + new Date().getTime()}
            overlay={seenByMenu()}
            trigger={["click"]}
            className="message-dropdown"
            placement="bottomRight"
          >
            <div
              className="message-seen-by"
              style={
                localStorage.getItem("RID") === message.senderId.toString()
                  ? { width: "100%" }
                  : {}
              }
            >
              {seenByUsers.map((user) => (
                <div key={'user-' + user.beamId} title={user.beamId} className='info-img'
                  style={{ backgroundImage: `url(${user.profileImage})` }}>
                </div>
              ))}
            </div>
          </Dropdown>
        )}
      </React.Fragment>
    );
  };

export default MessageItem;
